import styled from 'styled-components'

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 8px 0 4px;
`

export const Field = styled.input`
  width: 100%;
  /*
   * O reset global aplica border-box só em html e body, e a propriedade não é
   * herdada. Sem esta linha, a largura vira 100% mais 24px de padding mais 2px
   * de borda, e o campo estoura a lateral do drawer.
   */
  box-sizing: border-box;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 16px;
  outline: none;

  &:focus {
    border-color: #2f80ed;
  }
`

export const CodeField = styled(Field)`
  letter-spacing: 8px;
  text-align: center;
  font-size: 20px;
`

export const StepLabel = styled.span`
  font-size: 12px;
  opacity: 0.6;
`

export const Hint = styled.p`
  font-size: 13px;
  opacity: 0.7;
  margin: 0;
`

export const ErrorText = styled.p`
  font-size: 13px;
  color: #eb5757;
  margin: 0;
`

export const WarningText = styled.p`
  font-size: 13px;
  color: #f2994a;
  margin: 0;
`

export const Actions = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 8px;

  button {
    flex: 1;
    padding: 12px;
    border: none;
    border-radius: 8px;
    font-size: 15px;
    cursor: pointer;
  }

  button[type='submit'] {
    background: #27ae60;
    color: #fff;
  }

  button[type='button'] {
    background: #f0f0f0;
  }

  button:disabled {
    opacity: 0.5;
    cursor: default;
  }
`

export const Title = styled.h2`
  margin: 4px 0 2px;
  font-size: 18px;
  font-weight: 600;
  text-align: center;
  color: #222;
`

/**
 * Reenvio: dois botoes lado a lado, menores que os da acao principal. O
 * `tabular-nums` evita a contagem "pulando" de largura a cada segundo.
 */
export const ResendActions = styled.div`
  display: flex;
  gap: 8px;
  justify-content: center;

  button {
    flex: 1;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 8px;
    background: #fff;
    font-size: 13px;
    color: #333;
    cursor: pointer;
    font-variant-numeric: tabular-nums;
  }

  button:disabled {
    opacity: 0.5;
    cursor: default;
  }
`

export const NoticeText = styled.p`
  font-size: 13px;
  color: #27ae60;
  margin: 0;
`
